export function applyGuestDiscount(
  subtotal: number,
  percent: number,
): {
  subtotal: number;
  discountPercent: number;
  discountSum: number;
  payable: number;
} {
  const safe = Number.isFinite(subtotal) ? Math.max(0, subtotal) : 0;
  const p = Number.isFinite(percent) ? Math.min(100, Math.max(0, percent)) : 0;
  if (p <= 0) {
    return { subtotal: safe, discountPercent: 0, discountSum: 0, payable: safe };
  }
  const payable = Math.round((safe * (100 - p)) / 100);
  return {
    subtotal: safe,
    discountPercent: p,
    discountSum: Math.max(0, Math.round((safe - payable) * 100) / 100),
    payable,
  };
}
